import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgArrowRightIconSecondary from './svgs/ArrowRightIconSecondary.js';
import SvgArrowRightIcon from './svgs/ArrowRightIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var ArrowRightIcon = (props => useIcon(SvgArrowRightIcon, SvgArrowRightIconSecondary, props));

export { ArrowRightIcon as default };
